import { Auditoria, OrigemAuditoria, UsuarioAuditoria } from "@/types/Auditoria";
import { PagedResponse } from "@/types/PagedResponse";
import axios, { AxiosPromise } from "axios";

export type FiltroAuditoria = { origem: OrigemAuditoria; inicio?: string; fim?: string; usuario?: string; page?: number; size?: number };

export const buscar = (filtro: FiltroAuditoria): AxiosPromise<PagedResponse<Auditoria>> =>
    axios.get(`/api/auditoria`, { params: filtro });

// Quem já alterou algo na corretora (filtro da tela)
export const usuarios = (): AxiosPromise<UsuarioAuditoria[]> =>
    axios.get(`/api/auditoria/usuarios`);
